<script>
import { mapGetters } from 'vuex'
export default {
  name: 'PaymentConfirmation',
  props: {
    order: {
      type: Object,
      required: false
    }
  },
  data: () => ({

  }),
  computed: {
    ...mapGetters(['locale'])
  },
  methods: {
    exportCSV(order) {
      this.$ordersService.exportCSV(order?.orderId, order?.organizationId)
        .then(response => {
          this.$ordersService.clientCSVDownload(response,order?.orderId)
        })
        .catch((error) => {
          console.error('Error exporting CSV', error)
        });
    }
  }
}
</script>
<template>
  <v-container fluid>
    <v-row>
      <v-col md="8" sm="12" class="text-center mx-auto">
        <v-card outlined flat color="grey lighten-4">
          <v-card-text class="mt-12 primary--text">
            <p>{{ $t('component.upload.paymentConfirmation.success') }}</p>
            <p>{{ $t('component.upload.paymentConfirmation.iab.signature') }}</p>
            <p>{{ $t('component.upload.paymentConfirmation.success.subtext') }}</p>
          </v-card-text>
          <v-card-actions>
            <v-container>
              <v-row class="justify-center" dense>
                <v-col>
                  <v-btn
                    color="tertiary"
                    class="mb-2"
                    @click="exportCSV(order)">
                    <v-icon left>mdi-table-arrow-down</v-icon>
                    {{ $t('button.csv.export') }}
                  </v-btn>
                </v-col>
                <v-col>
                  <v-btn
                    :to="{
                      name: 'dashboard',
                      params: { locale: locale }}"
                    color="tertiary"
                    class="mb-2">
                    {{ $t('button.dashboard') }}
                    <v-icon left>mdi-chevron-right</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
